'use strict';

/*global app*/
/*global services*/
/*global sprintf*/
/*global invokeCallback*/
/*global createObjectCallBack*/
/*global formatAmountByUnit*/
/*global btArticle*/
/*global btHandlingUnit*/
/*global btConsolidationBox*/
/*global btConsolidationLocation*/
/*global btConsolidationArticle*/
/*global resClose*/
/*global resSuccess*/
/*global resError*/
/*global Promise*/
/*global tradingPartnerIdNutWorld*/

function Consolidation(containerId, consolidationData) {
  this.containerId = containerId;
  this.$container = $('#' + containerId);
  this.$body = null;

  this.consolidationData = consolidationData;

  this.packingData = {};
  this.interruptPacking = false;

  this.modal = null;

  this.init();
}

Consolidation.prototype = $.extend({}, {
  constructor: 'Consolidation',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$container.on('click', '.consolidation__choose-batch', function () {
      _this.chooseBatch();

      return false;
    });

    _this.$container.on('click', '.consolidation__pair-box', function () {
      _this.pairBox();

      return false;
    });

    _this.$container.on('click', '.consolidation__show-boxes-list', function () {
      _this.showBoxesList();

      return false;
    });

    _this.$container.on('click', '.consolidation__packing', function () {
      _this.packing();

      return false;
    });

    _this.$body.on('click', '.consolidation__print-box', function () {
      _this.printBox($(this).closest('.consolidation__box').data('rid'));

      return false;
    });

    _this.$body.on('click', '.consolidation__print-all-boxes', function () {
      _this.printAllBoxes();

      return false;
    });

    _this.$body.on('click', '.consolidation__print-box-article', function () {
      _this.printBoxArticle($(this).data('rid'));

      return false;
    });

    _this.$body.on('click', '.consolidation__show-location-info', function () {
      _this.showLocationInfo();

      return false;
    });

    _this.$body.on('click', '.consolidation__release-all-locations', function () {
      var $this = $(this);

      if (!$this.is('disabled')) {
        _this.releaseAllLocations();
      }

      return false;
    });

    _this.$body.on('click', '.consolidation__release-location--modal', function () {
      _this.modal.block();
      _this.releaseLocation($(this).data('location_id'), { ConsolidationBoxSpecificationLong: $(this).data('specification_long') }, function (res) {
        if (res === resSuccess) {
          _this.modal.unBlock();
          _this.modal.close();
        }
      });

      return false;
    });

    _this.$body.on('click', '.consolidation__show-article-info', function () {
      _this.showArticleInfo();

      return false;
    });

    _this.$body.on('click', '.consolidation__do-show-article-info', function () {
      _this.doShowArticleInfo($(this).data('article_id'), $(this).data('article_abbr'));

      return false;
    });

    _this.$body.on('click', '.consolidation__change-box-size--boxes-list', function () {
      var $box = $(this).closest('.consolidation__box');
      _this.changeBoxSize($box.data('rid'), $box.data('size'), function () {
        _this.showBoxesList();
      });

      return false;
    });

    _this.$body.on('click', '.consolidation__change-box-size--assign-to-hangling-unit', function () {
      var $btn = $(this);
      _this.changeBoxSize($(this).data('rid'), $(this).data('size'), function (size) {
        _this.packingData.ConsolidationBox.ConsolidationBoxSize = size;

        $btn.data('size', size);
      });

      return false;
    });

    _this.$body.on('click', '.consolidation__change-box-size--location-info', function () {
      var $btn = $(this);
      _this.changeBoxSize($btn.data('rid'), $btn.data('size'), function () {
        _this.doShowLocationInfo($btn.data('location_id'));
      });

      return false;
    });

    _this.$body.on('click', '.consolidation__change-boxes-size', function () {
      var $btn = $(this);
      _this.getBoxSize(function (size) {
        location.href = $btn.attr('href') + '?BoxSize=' + size;
      });

      return false;
    });

    _this.$body.on('click', '.consolidation__return-article', function () {
      _this.returnArticle();

      return false;
    });

    _this.$body.on('keyup', '.consolidation__location-input', function (e) {
      e = e || window.event;
      var keyCode = e.keyCode || e.which;

      if (keyCode === 0 || keyCode === undefined) {
        return _this;
      }

      if (keyCode === 13) {
        _this.changeLocationInput($(this).val());
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  chooseBatch: function chooseBatch() {
    var _this = this;

    app.getFormation('consolidation:get_batches', function (res) {
      if (res.msg === 'SUCCESS') {
        var list = [];
        $.each(res.data.list, function (key, item) {
          list.push({ id: item.RID, abbr: item.Name });
        });

        app.selectValue({ list: list }, function (RID) {
          location.href = services.get('router').path('consolidation_get_by_batch', { RID: RID });
        });
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  pairBoxAndLocationInternal: function pairBoxAndLocationInternal(consolidationBoxRID, forcePair, locationData, callback) {
    var _this = this;

    app.getFormation('consolidation:pair_box_and_location', { ConsolidationBoxRID: consolidationBoxRID, ForcePair: forcePair ? 1 : 0, LocationId: locationData.Id }, function (res) {
      if (res.msg === 'SUCCESS') {
        _this.updateInfo();

        invokeCallback(callback, resSuccess, locationData);
      } else {
        app.viewErrorMessage(res.error, function () {
          invokeCallback(callback, resError);
        });
      }
    });

    return _this;
  },

  pairBoxAndLocation: function pairBoxAndLocation(consolidationBoxRID, forcePair, callback) {
    var _this = this;

    services.get('barcode-service').scanAndFindBarcode(btConsolidationLocation, null, 0, function (res, resData) {
      if (res === resSuccess) {
        _this.pairBoxAndLocationInternal(consolidationBoxRID, forcePair, resData, callback);
      } else if (res === resError) {
        app.showMessageHtml(app.t('barcode.unknown'), function () {
          _this.pairBoxAndLocation(consolidationBoxRID, forcePair, callback);
        });
      } else {
        invokeCallback(callback, res);
      }
    });

    return _this;
  },

  pairBox: function pairBox(callback) {
    var _this = this;

    services.get('barcode-service').scanAndFindBarcode(btConsolidationBox, null, 0, function (res, resData) {
      if (res === resSuccess) {
        if (resData.LocationId) {
          app.confirmHtml(sprintf(app.t('consolidation.box_already_located_change_it'), resData.Abbr, resData.LocationAbbr), function (ret) {
            if (ret) {
              _this.pairBoxAndLocation(resData.RID, true, function () {
                _this.pairBox(callback);
              });
            } else {
              _this.pairBox(callback);
            }
          });
        } else {
          _this.pairBoxAndLocation(resData.RID, false, function () {
            _this.pairBox(callback);
          });
        }
      } else if (res === resError) {
        app.showMessageHtml(app.t('barcode.unknown'), function () {
          _this.pairBox(callback);
        });
      } else {
        invokeCallback(callback, res);
      }
    });

    return _this;
  },

  //---------------------------------------------------------------------------

  startPackingProcess: function startPackingProcess(callback) {
    var _this = this;

    //nejdrive naskenujeme zbozi, pak hned volame funkci na nacteni konsolidace

    services.get('barcode-service').scanBarcode('Načtěte <strong>zboží na konsolidaci</strong>', function (res, barcode) {
      if (res !== resSuccess) {
        return invokeCallback(callback);
      }

      var params = {
        Barcode: barcode,
        ConsolidationBatchRID: _this.consolidationData.ConsolidationBatchRID,
        DeliveryNoteRIDs: _this.consolidationData.DeliveryNoteRIDs
      };

      app.getFormation('consolidation:start_packing_process', params, function (res) {
        if (res.msg === 'SUCCESS') {
          if (res.data.ConsolidationBoxRID !== 0) {
            _this.packingData.ArticleId = res.data.ArticleId;
            _this.packingData.ArticleAbbr = res.data.ArticleAbbr;
            _this.packingData.ArticleName = res.data.ArticleName;
            _this.packingData.ArticleUnit = res.data.ArticleUnit;
            _this.packingData.IsHighlighted = res.data.IsHighlighted;
            _this.packingData.ConsolidationBoxRID = res.data.ConsolidationBoxRID;
            _this.packingData.ConsolidationBoxArticleRID = res.data.ConsolidationBoxArticleRID;
            _this.packingData.ConsolidationBox = res.data;

            invokeCallback(callback, resSuccess);
          } else if (res.data.ArticleAbbr) {
            _this.packingData.ArticleId = res.data.ArticleId;
            _this.packingData.ArticleAbbr = res.data.ArticleAbbr;

            var content = '';
            content += '<div class="text-center">';
            content += '<div class="offset-bottom-5">' + app.t('consolidation.box_article_not_found') + '</div>';
            content += '<div><a href="#" class="btn btn-primary consolidation__do-show-article-info" data-article_id="' + _this.packingData.ArticleId + '" data-article_abbr="' + _this.packingData.ArticleAbbr + '">Info o zboží</a></div>';
            content += '</div>';

            _this.modal.open();
            _this.modal.content(content);

            invokeCallback(callback, resClose);
          } else {
            app.showMessageHtml(app.t('barcode.unknown'), function () {
              _this.scanArticle(callback);
            });
          }
        } else {
          app.viewErrorMessage(res.error, function () {
            invokeCallback(callback, resError);
          });
        }
      });
    });

    return _this;
  },

  closePackingProcess: function closePackingProcess() {
    var _this = this;

    _this.packing();

    return _this;
  },

  submitPackingProcess: function submitPackingProcess(callback) {
    var _this = this;

    _this.modal.close(function () {
      invokeCallback(callback, resSuccess);
    });

    return _this;
  },

  packingProcess: function packingProcess(callback) {
    var _this = this;

    var html = '';
    html += '<div class="text-center">';

    if (_this.packingData.ConsolidationBox.AlreadyStarted) {
      html += '<div class="text-danger offset-bottom-5">' + app.t('consolidation.packing_already_started') + '</div>';
    }

    html += '<div>' + app.t('article.title') + ' / ' + app.t('amount') + '</div>';
    html += '<div><strong>' + _this.packingData.ArticleAbbr + '</strong></div>';
    html += '<div class="' + (_this.packingData.IsHighlighted ? 'text-warning' : '') + '">' + (_this.packingData.IsHighlighted ? '<span class="glyphicon glyphicon-tag text-danger"></span> ' : '') + _this.packingData.ArticleName + '</div>';
    html += '<div class="offset-top-10 font-size-150per ' + (_this.packingData.ConsolidationBox.Quantity > 1 ? 'text-danger' : '') + '"><strong>' + formatAmountByUnit(_this.packingData.ConsolidationBox.Quantity, _this.packingData.ArticleUnit) + ' ' + _this.packingData.ArticleUnit + '</strong></div>';
    html += '<div class="offset-top-10">' + app.t('location.title') + ' | ' + app.t('consolidation.box') + ' </div>';
    html += '<div class="font-size-150per"><strong>' + _this.packingData.ConsolidationBox.LocationAbbr + '</strong> | <strong class="font-size-75per">' + _this.packingData.ConsolidationBox.ConsolidationBoxAbbr + '</strong>' + (_this.packingData.ConsolidationBox.ConsolidationBoxSpecification ? ' (' + _this.packingData.ConsolidationBox.ConsolidationBoxSpecification + ')' : '')  + ' <span class="font-size-75per">' + app.t('items_count') + ' ' + _this.packingData.ConsolidationBox.ConsolidationBoxItemsCount + '</span></div>';
    html += '<div class="offset-top-5"><a href="#" class="btn btn-default consolidation__print-box-article" data-rid="' + _this.packingData.ConsolidationBox.ConsolidationBoxArticleRID + '">' + app.t('printer.print') + '</a></div>';

    //u baleni dle davky umoznujeme nacist umisteni pouze pro jednokuse objednavky
    if (_this.consolidationData.TradingPartnerId !== tradingPartnerIdNutWorld || _this.packingData.ConsolidationBox.Quantity <= 1) {
      html += '<div class="offset-top-5"><input type="text" class="form-control consolidation__location-input" placeholder="' +  app.t('location.title') + '" /></div>';
    }

    html += '</div>';

    _this.modal.open({
      height: 'auto',
      width: 'md',
      closeCallBack: createObjectCallBack(_this, 'closePackingProcess'),
      submitCallBack: createObjectCallBack(_this, 'submitPackingProcess', callback),
      form: true,
      saveBtnTitle: app.t('consolidation.packing_process'),
      focusTimeout: 500,
    });
    _this.modal.content(html);

    return _this;
  },

  assignToLocation: function assignToLocation(callback) {
    var _this = this;

    _this.pairBoxAndLocation(_this.packingData.ConsolidationBoxRID, false, function (res, resData) {
      if (res === resError) {
        _this.assignToLocation(callback);
      } else {
        invokeCallback(callback, res, resData);
      }
    });

    return _this;
  },

  confirmLocation: function confirmLocation(callback) {
    var _this = this;

    services.get('barcode-service').scanAndFindBarcode(btConsolidationLocation, sprintf(app.t('consolidation.confirm_location'), _this.packingData.ConsolidationBox.LocationAbbr), 0, function (res, resData) {
      if (res === resSuccess) {
        if (resData.Id === _this.packingData.ConsolidationBox.LocationId) {
          //pokud box souhlasi
          invokeCallback(callback, resSuccess);
        } else {
          app.showMessageHtml(app.t('consolidation.location_mismatch'), function () {
            _this.confirmLocation(callback);
          });
        }
      } else if (res === resError) {
        app.showMessageHtml(app.t('barcode.unknown'), function () {
          _this.confirmLocation(callback);
        });
      } else {
        invokeCallback(callback, resError);
      }
    });

    return _this;
  },

  finishPackingProcess: function finishPackingProcess(callback) {
    var _this = this;

    app.getFormation('consolidation:finish_packing_process', { ConsolidationBoxRID: _this.packingData.ConsolidationBoxRID, ConsolidationBoxArticleRID: _this.packingData.ConsolidationBox.ConsolidationBoxArticleRID }, function (res) {
      if (res.msg === 'SUCCESS') {
        _this.packingData.ConsolidationBox = $.extend(_this.packingData.ConsolidationBox, res.data);

        invokeCallback(callback, resSuccess);
      } else {
        app.viewErrorMessage(res.error, function () {
          invokeCallback(callback, resError);
        });
      }
    });

    return _this;
  },

  assignToHandlingUnit: function assignToHandlingUnit(callback) {
    var _this = this;

    if (_this.packingData.ConsolidationBox.LocationId) {
      //pokud mam sparovane s umistenim, zeptam se
      app.confirmHtml(sprintf(app.t('consolidation.box_is_done_move_to_handling_unit'), _this.packingData.ConsolidationBox.ConsolidationBoxAbbr, _this.packingData.ConsolidationBox.ConsolidationBoxSpecification ? '(' + _this.packingData.ConsolidationBox.ConsolidationBoxSpecification + ')' : '', _this.packingData.ConsolidationBox.LocationAbbr), function (ret) {
        if (ret) {
          _this.assignBoxToHandlingUnit(_this.packingData.ConsolidationBoxRID, _this.packingData.ConsolidationBox, function (res) {
            if (res === resSuccess) {
              invokeCallback(callback, resSuccess);
            } else {
              _this.assignToHandlingUnit(callback);
            }
          });
        } else {
          invokeCallback(callback, resSuccess);
        }
      });
    } else {
      //pokud nemam, nic jineho mi nezbyva
      _this.assignBoxToHandlingUnit(_this.packingData.ConsolidationBoxRID, _this.packingData.ConsolidationBox, function (res) {
        if (res === resSuccess) {
          invokeCallback(callback, resSuccess);
        } else {
          _this.assignToHandlingUnit(callback);
        }
      });
    }

    return _this;
  },

  //-----------------------------------------------------------------------------------

  doStartPackingProcess: function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      _this.startPackingProcess(function (ret) {
        if (ret === resSuccess) {
          resolve();
        } else if (ret === resError) {
          //vznikla nejaka chyba - prerusime zpracovani, ale neukoncujeme, zacneme od zacatku

          _this.interruptPacking = false;

          reject();
        } else {
          //zavirame formular - ukoncujeme zpracovani

          _this.interruptPacking = true;

          reject();
        }
      });
    });
  },

  doPackingProcess: function doPackingProcess() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      _this.packingProcess(function (ret) {
        if (ret === resSuccess) {
          resolve();
        } else {
          //vznikla nejaka chyba - prerusime zpracovani, ale neukoncujeme, zacneme od zacatku

          _this.interruptPacking = false;

          reject();
        }
      });
    });
  },

  doAssignToLocation: function doAssignToLocation() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.packingData.ConsolidationBox.ConsolidationBoxItemsCount === 1 || _this.packingData.ConsolidationBox.LocationId !== 0) {
        //pokud mame jen jednou polozku, nebo je jiz sparovano, nebudeme znovu parovat

        resolve();
      } else {
        _this.assignToLocation(function (res, resData) {
          if (res === resSuccess) {
            _this.packingData.ConsolidationBox.LocationId = resData.Id;
            _this.packingData.ConsolidationBox.LocationAbbr = resData.Abbr;
            _this.packingData.ConsolidationBox.LocationConfirmed = true;

            resolve();
          } else {
            //vznikla nejaka chyba - prerusime zpracovani, ale neukoncujeme, zacneme od zacatku

            _this.interruptPacking = false;

            reject();
          }
        });
      }
    });
  },

  doConfirmLocation: function doConfirmLocation() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.packingData.ConsolidationBox.LocationConfirmed || !_this.packingData.ConsolidationBox.LocationId) {
        //pokud je potvrzene, tak neresime

        resolve();
      } else {
        _this.confirmLocation(function (ret) {
          if (ret === resSuccess) {
            resolve();
          } else {
            //vznikla nejaka chyba - prerusime zpracovani, ale neukoncujeme, zacneme od zacatku

            _this.interruptPacking = false;

            reject();
          }
        });
      }
    });
  },

  doFinishPackingProcess: function doFinishPackingProcess() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      _this.finishPackingProcess(function (ret) {
        if (ret === resSuccess) {
          resolve();
        } else {
          //vznikla nejaka chyba - prerusime zpracovani, ale neukoncujeme, zacneme od zacatku

          _this.interruptPacking = false;

          reject();
        }
      });
    });
  },

  doAssignToHandlingUnit: function doAssignToHandlingUnit() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (_this.packingData.ConsolidationBox.IsDone) {
        _this.assignToHandlingUnit(function (ret) {
          if (ret === resSuccess) {
            resolve();
          } else {
            //vznikla nejaka chyba - prerusime zpracovani, ale neukoncujeme, zacneme od zacatku

            _this.interruptPacking = false;

            reject();
          }
        });
      } else {
        resolve();
      }
    });
  },

  packing: function packing() {
    var _this = this;

    _this.packingData = {};
    _this.interruptPacking = false;

    var promise = Promise.resolve();

    //naskenujeme zbozi, zobrazime a vytiskneme stitek
    promise = promise.then(function () {
      return _this.doStartPackingProcess();
    });

    //zobrazime balici informace, provedeme baleni
    promise = promise.then(function () {
      return _this.doPackingProcess();
    });

    //sparujeme box s umistenim
    promise = promise.then(function () {
      return _this.doAssignToLocation();
    });

    //potvrdime umistei, do ktereho davame zbozi
    promise = promise.then(function () {
      return _this.doConfirmLocation();
    });

    //dokoncime proces zabaleni
    promise = promise.then(function () {
      return _this.doFinishPackingProcess();
    });

    //pokud jsem dokoncil box, tak dam na MJ
    promise = promise.then(function () {
      return _this.doAssignToHandlingUnit();
    });

    //nakonec znovu zobrazime
    promise = promise.finally(function () {
      if (!_this.interruptPacking) {
        _this.packing();
      }
    });

    return _this;
  },

  //-----------------------------------------------------------------------------------

  showBoxesList: function showBoxesList() {
    var _this = this;

    _this.modal.open();
    _this.modal.block();
    $.get(app.path('consolidation_boxes_list'), { ConsolidationBatchRID: _this.consolidationData.ConsolidationBatchRID, DeliveryNoteRIDs: _this.consolidationData.DeliveryNoteRIDs }, function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  printBox: function (RID) {
    var _this = this;

    app.printer.printConsolidationBox(RID);

    return _this;
  },

  printAllBoxes: function printAllBoxes() {
    var _this = this;

    app.printer.printConsolidationBoxes(_this.consolidationData.ConsolidationBatchRID, _this.consolidationData.DeliveryNoteRIDs);

    return _this;
  },

  printBoxArticle: function printBoxArticle(RID) {
    var _this = this;

    app.printer.printConsolidationBoxArticle(RID);

    return _this;
  },

  doShowLocationInfo: function doShowLocationInfo(locationId) {
    var _this = this;

    _this.modal.open();
    _this.modal.block();
    $.get(app.path('consolidation_location_info'), { LocationId: locationId }, function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  showLocationInfo: function showLocationInfo() {
    var _this = this;

    services.get('barcode-service').scanAndFindBarcode(btConsolidationLocation, null, 0, function (res, resData) {
      if (res === resSuccess) {
        _this.doShowLocationInfo(resData.Id);
      } else if (res === resError) {
        app.showMessageHtml(app.t('barcode.unknown'), function () {
          _this.showLocationInfo();
        });
      }
    });

    return _this;
  },

  releaseAllLocations: function releaseAllLocations() {
    var _this = this;

    app.confirmHtml(app.t('consolidation.release_all_locations_confirm'), function (ret) {
      if (!ret) {
        return;
      }

      app.getFormation('consolidation:release_all_locations', { ConsolidationBatchRID: _this.consolidationData.ConsolidationBatchRID, DeliveryNoteRIDs: _this.consolidationData.DeliveryNoteRIDs }, function (res) {
        if (res.msg === 'SUCCESS') {
          app.showMessageHtml(app.t('consolidation.all_released'));
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    });

    return _this;
  },

  doReleaseLocation: function doReleaseLocation(locationId, handlingUnitRID, callback) {
    app.getFormation('consolidation:release_location', { LocationId: locationId, HandlingUnitRID: handlingUnitRID }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.showMessageHtml(app.t('consolidation.box_assigned_to_handling_unit'), function () {
          invokeCallback(callback, resSuccess);
        });
      } else {
        app.viewErrorMessage(res.error, function () {
          invokeCallback(callback, resError);
        });
      }
    });
  },

  releaseLocation: function releaseLocation(locationId, consolidationBox, callback) {
    var _this = this;

    var title = '<div>Načtěte štítek <strong>manipulační jednotky</strong> (' + consolidationBox.ConsolidationBoxSpecificationLong + ')</div>';

    services.get('barcode-service').scanAndFindBarcode(btHandlingUnit, title, 0, function (res, resData) {
      if (res === resSuccess) {
        _this.doReleaseLocation(locationId, resData.RID, callback);
      } else if (res === resError) {
        app.showMessageHtml(app.t('barcode.unknown'), function () {
          _this.releaseLocation(locationId, consolidationBox, callback);
        });
      } else {
        invokeCallback(callback, resError);
      }
    });

    return _this;
  },

  doAssignBoxToHandlingUnit: function doAssignBoxToHandlingUnit(consolidationBoxRID, handlingUnitRID, callback) {
    app.getFormation('consolidation:assign_box_to_handling_unit', { ConsolidationBoxRID: consolidationBoxRID, HandlingUnitRID: handlingUnitRID }, function (res) {
      if (res.msg === 'SUCCESS') {
        app.showMessageHtml(app.t('consolidation.box_assigned_to_handling_unit'), function () {
          invokeCallback(callback, resSuccess);
        });
      } else {
        app.viewErrorMessage(res.error, function () {
          invokeCallback(callback, resError);
        });
      }
    });
  },

  assignBoxToHandlingUnit: function assignBoxToHandlingUnit(RID, consolidationBox, callback) {
    var _this = this;

    var title = '<div class="text-right"><a href="#" class="btn btn-primary consolidation__change-box-size--assign-to-hangling-unit" data-rid="' + RID + '" data-size="' + consolidationBox.ConsolidationBoxSize + '">Změna boxu</a></div>';
    title += '<div>Načtěte štítek <strong>manipulační jednotky</strong> (' + consolidationBox.ConsolidationBoxSpecificationLong + ')</div>';

    services.get('barcode-service').scanAndFindBarcode(btHandlingUnit, title, 0, function (res, resData) {
      if (res === resSuccess) {
        _this.doAssignBoxToHandlingUnit(RID, resData.RID, callback);
      } else if (res === resError) {
        app.showMessageHtml(app.t('barcode.unknown'), function () {
          _this.assignBoxToHandlingUnit(RID, consolidationBox, callback);
        });
      } else {
        invokeCallback(callback, resError);
      }
    });

    return _this;
  },

  doShowArticleInfo: function doShowArticleInfo(articleId, articleAbbr) {
    var _this = this;

    _this.modal.open();
    _this.modal.block();
    $.get(app.path('consolidation_article_info'), { ArticleId: articleId, ArticleAbbr: articleAbbr, ConsolidationBatchRID: _this.consolidationData.ConsolidationBatchRID, DeliveryNoteRIDs: _this.consolidationData.DeliveryNoteRIDs }, function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  showArticleInfo: function showArticleInfo() {
    var _this = this;

    var type = null;
    var param = null;
    if (_this.consolidationData.ConsolidationBatchRID) {
      type = btConsolidationArticle;
      param = _this.consolidationData.ConsolidationBatchRID;
    } else {
      type = btArticle;
      param = _this.consolidationData.TradingPartnerId;
    }

    services.get('barcode-service').scanAndFindBarcode(type, null, param, function (res, resData) {
      if (res === resSuccess) {
        _this.doShowArticleInfo(resData.Id, resData.Abbr);
      } else if (res === resError) {
        app.showMessageHtml(app.t('barcode.unknown'), function () {
          _this.showArticleInfo();
        });
      }
    });

    return _this;
  },

  updateInfo: function updateInfo() {
    var _this = this;

    if (_this.consolidationData.DeliveryNoteRIDs) {
      app.getFormation('consolidation:get_info', { ConsolidationBatchRID: _this.consolidationData.ConsolidationBatchRID, DeliveryNoteRIDs: _this.consolidationData.DeliveryNoteRIDs }, function (res) {
        _this.$container.find('.consolidation__total-boxes-count').text(res.data.TotalBoxesCount);
        _this.$container.find('.consolidation__paired-boxes-count').text(res.data.PairedBoxesCount);
        _this.$container.find('.consolidation__to-pair-boxes-count').text(res.data.TotalBoxesCount - res.data.PairedBoxesCount);
        _this.$container.find('.consolidation__picking-locations-prepared-items').text(Math.round(res.data.PickingLocationsPreparedItems));
        _this.$container.find('.consolidation__picking-no-locations-prepared-items').text(Math.round(res.data.PickingNoLocationsPreparedItems));
        _this.$container.find('.consolidation__production-count').text(Math.round(res.data.ProductionCount));

        if (res.data.PercentageCompleteCalc >= 100) {
          var $btn = _this.$container.find('.consolidation__release-all-locations');
          $btn.removeClass('btn-default');
          $btn.addClass('btn-primary');
          $btn.removeAttr('disabled');
        }
      });
    }

    return _this;
  },

  changeBoxSize: function changeBoxSize(consolidationBoxRID, size, callback) {
    var _this = this;

    app.selectValue({ list: app.param('consolidation_box_sizes'), value: size }, function (size) {
      _this.modal.block();
      app.getFormation('consolidation:change_box_size', { ConsolidationBoxRID: consolidationBoxRID, BoxSize: size }, function (res) {
        _this.modal.unBlock();

        if (res.msg === 'SUCCESS') {
          invokeCallback(callback, size);
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    });

    return _this;
  },

  getBoxSize: function getBoxSize(callback) {
    var _this = this;

    app.selectValue({ list: app.param('consolidation_box_sizes') }, function (size) {
      invokeCallback(callback, size);
    });

    return _this;
  },

  changeLocationInput: function changeLocationInput(abbr) {
    var _this = this;

    services.get('barcode-service').findConsolidationLocation(abbr, function (res, resData) {
      if (res === resSuccess) {
        if (_this.packingData.ConsolidationBox.LocationId) {
          //jiz je sparovane, pouze potvrzujeme umisteni
          _this.packingData.ConsolidationBox.LocationConfirmed = _this.packingData.ConsolidationBox.LocationId === resData.Id;

          _this.modal.submit();
        } else {
          //jeste neni sparovane, musime sparovat
          _this.pairBoxAndLocationInternal(_this.packingData.ConsolidationBoxRID, false, resData, function (res) {
            if (res === resSuccess) {
              _this.packingData.ConsolidationBox.LocationId = resData.Id;
              _this.packingData.ConsolidationBox.LocationAbbr = resData.Abbr;
              _this.packingData.ConsolidationBox.LocationConfirmed = true;
            }

            _this.modal.submit();
          });
        }
      } else {
        _this.modal.submit();
      }
    });

    return _this;
  },

  doReturnArticle: function doReturnArticle(articleId, articleAbbr) {
    var _this = this;

    _this.modal.open();
    _this.modal.block();
    $.get(app.path('consolidation_return_article'), { ArticleId: articleId, ArticleAbbr: articleAbbr, ConsolidationBatchRID: _this.consolidationData.ConsolidationBatchRID }, function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  returnArticle: function returnArticle() {
    var _this = this;

    var type = null;
    var param = null;
    if (_this.consolidationData.ConsolidationBatchRID) {
      type = btConsolidationArticle;
      param = _this.consolidationData.ConsolidationBatchRID;
    } else {
      type = btArticle;
      param = _this.consolidationData.TradingPartnerId;
    }

    services.get('barcode-service').scanAndFindBarcode(type, null, param, function (res, resData) {
      if (res === resSuccess) {
        _this.doReturnArticle(resData.Id, resData.Abbr);
      } else if (res === resError) {
        app.showMessageHtml(app.t('barcode.unknown'), function () {
          _this.returnArticle();
        });
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$body = $('body');

    _this.registerCallbacks();

    _this.modal = services.get('modal-consolidation');

    _this.updateInfo();

    return _this;
  }
});
